"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RaydiumLPDepositAction = void 0;
const sdk_1 = require("@malloc-protocol/sdk");
const web3_js_1 = require("@solana/web3.js");
const cpi_action_json_1 = __importDefault(require("../../target/idl/cpi_action.json"));
const raydium = __importStar(require("@raydium-io/raydium-sdk"));
const cpi_action_1 = require("../utils/cpi-action");
const bn_js_1 = __importDefault(require("bn.js"));
const raydium_utils_1 = require("./raydium-utils");
const { getTokenAccountUsedByMalloc, getMintInfo } = sdk_1.utils.tokens;
const actionTypeUID = "MALLOC_SPL_RAYDIUM_LP_DEPOSIT";
const buildIsolatedRaydiumLPDeposit = ({ inp, inputTokens: inpTokAccounts, actionPID, provider, authority, opts, }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    if (inpTokAccounts.length !== 2)
        throw `LP depositing expects 2 input tokens`;
    const liquidityPool = (_a = inp.liquidityPool) !== null && _a !== void 0 ? _a : (inp.hasFarm
        ? yield (0, raydium_utils_1.getMainnetRaydiumPools)({
            matchesMints: [inpTokAccounts[0].mint, inpTokAccounts[1].mint],
            version: 4,
            hasFarm: {},
        })
        : yield (0, raydium_utils_1.getMainnetRaydiumPools)({
            matchesMints: [inpTokAccounts[0].mint, inpTokAccounts[1].mint],
            version: 4,
        }))[0]; // TODO: this just fetches the first found
    if (!liquidityPool) {
        throw `A liquidity pool cannot be found for the inputted tokens`;
    }
    const dummy1Amount = new bn_js_1.default(0);
    const dummy2Amount = new bn_js_1.default(0);
    const mint1 = inpTokAccounts[0].mint;
    const mint2 = inpTokAccounts[1].mint;
    // Append the data to signify if the first amount is the pc amount
    const firstInAmountIsQuoteMint = mint1.toBase58() === liquidityPool.quoteMint.toBase58() ? 1 : 0;
    if (!((mint1.equals(liquidityPool.quoteMint) &&
        mint2.equals(liquidityPool.baseMint)) ||
        (mint1.equals(liquidityPool.baseMint) &&
            mint2.equals(liquidityPool.quoteMint)))) {
        throw `LP depositing expects the 2 input token mints to match the liquidity pool's mints`;
    }
    const quoteAccount = mint1.toBase58() === liquidityPool.quoteMint.toBase58()
        ? inpTokAccounts[0].tokenAccount
        : inpTokAccounts[1].tokenAccount;
    const baseAccount = mint1.toBase58() === liquidityPool.baseMint.toBase58()
        ? inpTokAccounts[0].tokenAccount
        : inpTokAccounts[1].tokenAccount;
    const mintOut = new web3_js_1.PublicKey(liquidityPool.lpMint);
    const userLpTokAccount = yield getTokenAccountUsedByMalloc(authority, mintOut, opts.preferredTokenAccounts);
    const addLiquidityParams = {
        poolKeys: liquidityPool,
        userKeys: {
            owner: authority,
            baseTokenAccount: baseAccount,
            quoteTokenAccount: quoteAccount,
            lpTokenAccount: userLpTokAccount,
        },
        fixedSide: "base",
        // for the amount with the smaller value
        // TODO: this is like which side it "takes" from. Make fixed side/ not care
        // and have the smart contract deal with this...
        // be based off of estimate somehow...
        maxBaseAmountIn: dummy1Amount,
        maxQuoteAmountIn: dummy2Amount,
    };
    const inst = raydium.Liquidity.makeAddLiquidityInstruction(addLiquidityParams);
    const dataWithoutExtra = (0, cpi_action_1.packInstrData)(inst.data, cpi_action_1.InstructionType.RAYDIUM_POOL_LIQUIDITY_DEPOSIT);
    const data = Buffer.from(new Uint8Array([
        ...dataWithoutExtra,
        ...new Uint8Array([firstInAmountIsQuoteMint]),
    ]));
    // TODO: have a more rigorous check of estimated outs somehow?
    return {
        // estimate out amounts by putting in amount for coin 1 and amount for coin 2
        // and then returning the minimum out
        estimateOuts: (amounts) => __awaiter(void 0, void 0, void 0, function* () {
            const mint1 = amounts[0].mint.toBase58();
            const mint2 = amounts[1].mint.toBase58();
            const mintData = yield getMintInfo(provider.connection, liquidityPool.lpMint);
            const estimateMint1Prom = getOutAmount(liquidityPool, provider.connection, mint1, mint2, new bn_js_1.default(amounts[0].amount), mintData.supply);
            const estimateMint2Prom = getOutAmount(liquidityPool, provider.connection, mint2, mint1, new bn_js_1.default(amounts[1].amount), mintData.supply);
            const [estimateMint1, estimateMint2] = yield Promise.all([
                estimateMint1Prom,
                estimateMint2Prom,
            ]);
            if (estimateMint1.gt(estimateMint2)) {
                return [
                    {
                        mint: mintOut,
                        amount: estimateMint2,
                    },
                ];
            }
            else {
                return [
                    {
                        mint: mintOut,
                        amount: estimateMint1,
                    },
                ];
            }
        }),
        isolatedAction: {
            actionTypeUID,
            tokenMintIn: inpTokAccounts.map((m) => m.mint),
            actionData: data,
            actionProgram: new web3_js_1.PublicKey(actionPID),
            actionAccounts: [
                { address: inst.programId },
                ...sdk_1.utils.object.actionMetasToAccountsArray(inst.keys),
            ],
            additionalSigners: [],
            tokenMintOuts: [mintOut],
            tokenAccountOuts: [userLpTokAccount],
        },
    };
});
exports.RaydiumLPDepositAction = {
    buildIsolatedAction: buildIsolatedRaydiumLPDeposit,
    actionTypeUID,
    expectedNumberOutMints: 1,
    idl: cpi_action_json_1.default,
};
const getOutAmount = (poolInfo, connection, fromCoinMint, toCoinMint, fromAmount, lpMintTotalSupply) => __awaiter(void 0, void 0, void 0, function* () {
    const [baseTokenAccount, quoteTokenAccount] = yield Promise.all([
        sdk_1.utils.tokens.getTokenAccountInfo(connection, poolInfo.baseVault),
        sdk_1.utils.tokens.getTokenAccountInfo(connection, poolInfo.quoteVault),
    ]);
    const baseBalance = baseTokenAccount.amount;
    const quoteBalance = quoteTokenAccount.amount;
    if (fromCoinMint === poolInfo.baseMint.toBase58() &&
        toCoinMint === poolInfo.quoteMint.toBase58()) {
        const baseAmount = fromAmount;
        return baseAmount.mul(lpMintTotalSupply).div(baseBalance);
    }
    else if (fromCoinMint === poolInfo.quoteMint.toBase58() &&
        toCoinMint === poolInfo.baseMint.toBase58()) {
        const quoteAmount = fromAmount;
        return quoteAmount.mul(lpMintTotalSupply).div(quoteBalance);
    }
    else {
        throw `An unexpected error occurred in estimating the amount out`;
    }
});
